import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ClassandsectionService from "../../services/classandsection.service";



export const fetchStandards = createAsyncThunk(
  "classandsection/fetchstandard",
  async (payload, thunkAPI) => {
    try {
      const response =
        await ClassandsectionService.getStandard(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const fetchSection = createAsyncThunk(
  "classandsection/fetchsection",
  async (payload, thunkAPI) => {
    try {
      const response =
        await ClassandsectionService.getSection(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,

standards: [],
sections: [],

  selectedclasssection: null,
  updateSuccess: false,
};

const classandsectionSlice = createSlice({
  name: "classandsection",
  initialState,

  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchStandards.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchStandards.fulfilled, (state, action) => {
        state.loading = false;
        state.standards = action.payload?.data || [];
      })

      .addCase(fetchStandards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchSection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchSection.fulfilled, (state, action) => {
        state.loading = false;
        state.sections = action.payload?.data || [];
      })

      .addCase(fetchSection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = classandsectionSlice.actions;
export default classandsectionSlice.reducer;
